import { render, staticRenderFns } from "./DetailContact.vue?vue&type=template&id=61cdf830&"
import script from "./DetailContact.vue?vue&type=script&lang=js&"
export * from "./DetailContact.vue?vue&type=script&lang=js&"
import style0 from "./DetailContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports